import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Select, Row, Col } from "antd";
import { DataTable, RadioGroup, Button } from '@life-line-lab/components-react';
import { map } from 'lodash';
import { Empty } from 'antd';
import './orders.scss';

const ChooseOrders = ({ orderList, selectedOrder }) => {

    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState<any>({})

    useEffect(() => {

    }, [])

    const onOrderSelect = (val) => {
        setSelectedIndex(val)
    }

    const onSubmit = () => {
        selectedOrder(orderList[selectedIndex])
    }

    return (
        <div className="">
            <h2 className="center">{t('title.chooseOrders')}</h2>

            <div className="fixed-box">
                <div>
                    {orderList.length == 0 ?
                        <div style={{ marginTop: '100px', fontSize: '22px', textAlign: 'center' }}>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                <span>
                                    {t('title.noOrdersFound')}
                                </span>
                            } />
                        </div> : null}
                </div>
                <RadioGroup
                    direction="vertical"
                    name="product"
                    value={selectedIndex}
                    onChange={(event) => onOrderSelect(event.target.value)}
                    options={map(orderList, (order, i) => {
                        return {
                            value: i, label:
                                <div className="orders">
                                    <Row gutter={16}>
                                        <Col lg={1} md={1} sm={1} xs={0} className="info"></Col>
                                        <Col lg={16} md={16} sm={16} xs={16} className="info">
                                            <div style={{ textTransform: 'capitalize', fontSize: '16px', color: '#858C94', lineHeight: '1.5rem' }}> <strong>#{order.orderCode}</strong></div>
                                            <div style={{ textTransform: 'capitalize', fontSize: '16px', color: '#0D1C2E', lineHeight: '1.5rem' }}> <strong>Order Total: <span style={{ color: '#196aaf' }}>{order?.paymentDetails?.total}</span></strong></div>
                                            <div style={{ textTransform: 'capitalize', fontSize: '16px', color: '#7DB83E', lineHeight: '1.5rem' }}> <strong>{order.status}</strong></div>
                                        </Col>
                                    </Row>
                                </div>
                        }
                    })}
                />
            </div>
            <div className="center">
                {orderList.length ?
                    <Button
                        type="primary"
                        label={t('action.submit')}
                        size="large"
                        onClick={onSubmit}
                    /> : null}
            </div>
        </div>
    );
};

export default ChooseOrders;